/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".divCard[_ngcontent-%COMP%]{max-width:800px;box-shadow:0 2px 7px 0 rgba(0,0,0,.5);padding:20px 0 0;text-align:center;border-radius:10px;display:inline-block;background-color:#fff}.membercard-logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:125px Important}\n/*# sourceMappingURL=card.component.css.map*/"];
export { styles as styles };
